var exports = {
  "nD": "Accordion__AnA-ht",
  "bc": "dividers__QFst4q",
  "q7": "Item__w9BoZ8",
  "DZ": "Heading__umGILq",
  "l9": "Trigger__PXjcL2",
  "ZY": "trailing__8RPFTx",
  "R4": "leading__G3njtu",
  "JU": "Label__eDOVx5",
  "Jc": "LeadingVisual__rpRIew",
  "cL": "Chevron__l6PSAM",
  "wq": "PanelContent__TQdWv_",
};

module.exports = exports;
